import { createSelector, } from 'reselect';
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectProjectAgentsFunc = (agentsByIdByProjectId, agentIdsByProjectId, projectId) => {
    var _a;
    return (_a = agentIdsByProjectId === null || agentIdsByProjectId === void 0 ? void 0 : agentIdsByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a.reduce((result, agentId) => {
        var _a;
        const agent = (_a = agentsByIdByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a[agentId];
        if (agent) {
            return [
                ...result,
                agent,
            ];
        }
        return result;
    }, []);
};
/**
 * Select ALL agents for a specific project
 */
export const selectProjectAgents = createSelector((state) => { return state.projectAgents.agentsByIdByProjectId; }, (state) => { return state.projectAgents.agentIdsByProjectId; }, (state, projectId) => { return projectId; }, selectProjectAgentsFunc);
export const selectProjectAgent = (state, projectId, agentId) => {
    var _a;
    return projectId && agentId
        ? (_a = state.projectAgents.agentsByIdByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a[agentId]
        : undefined;
};
